import { IconCircleCheck, IconCircleClose } from '@/presentation/components/icons';
import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { uploadFromCsvStudentState } from '../atoms';
import SelectKV from '../../components/select-kv';
import Styles from '../../styles/steps-styles.scss';
import CustomBootstrapTable from '@/presentation/components/custom-bootstrap-table/custom-bootstrap-table';
import { isMobile } from 'mobile-device-detect';
const columnStyle = { overflowWrap: 'break-word', fontSize: 13, fontWeight: 400 };
const headerStyle = { fontSize: 14, fontWeight: 500 };
const REQUIRED_FIELDS_1 = [
    {
        label: 'First Name',
        varName: 'firstName',
        regExpWords: ['first', 'name']
    },
    {
        label: 'Last Name',
        varName: 'lastName',
        regExpWords: ['last', 'name']
    },
    {
        label: 'Email',
        varName: 'email',
        regExpWords: ['email']
    }
];
const REQUIRED_FIELDS_2 = [
    ...REQUIRED_FIELDS_1,
    {
        label: 'Class Grade',
        varName: 'classGrade',
        regExpWords: ['class', 'grade']
    }
];
const columns1 = [
    {
        dataField: 'matched',
        text: 'Matched',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'requiredInfo',
        text: 'Required Information',
        headerStyle: Object.assign({ width: '25%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'dropdowns',
        text: 'From your CSV',
        headerStyle: Object.assign({ width: '30%' }, headerStyle),
        style: columnStyle,
        sort: true
    },
    {
        dataField: 'previewInfo',
        text: 'Preview Information',
        headerStyle: Object.assign({ width: '10%' }, headerStyle),
        style: columnStyle
    }
];
function validateSimilarity(string, words) {
    const regex = new RegExp(words.join('|'), 'gi');
    const matches = string.match(regex) || [];
    return matches.length === words.length;
}
const buildPreview = (string1, string2) => {
    return (React.createElement("div", null,
        React.createElement("div", null, string1),
        React.createElement("div", null, string2)));
};
const Step1 = () => {
    const [state, setState] = useRecoilState(uploadFromCsvStudentState);
    const REQUIRED_FIELDS = state.isSmallGroup ? REQUIRED_FIELDS_2 : REQUIRED_FIELDS_1;
    const { step, fileParsedResult, fieldMap } = state;
    const { data } = fileParsedResult;
    const columns = Object.keys(data[0]);
    const options = (React.createElement(React.Fragment, null,
        React.createElement("option", { value: "skip" }, "Skip"),
        React.createElement("option", { disabled: true }, "--------------"),
        columns.map((item, key) => (React.createElement("option", { value: item, key: `${item}_${key}` }, item)))));
    const doFirstMapping = () => {
        setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
        const fieldMapToSet = {
            firstMapping: true,
            firstNameColumnMatched: '',
            lastNameColumnMatched: '',
            emailColumnMatched: '',
            classGradeColumnMatched: ''
        };
        const stateToSet = {};
        REQUIRED_FIELDS.forEach(item => {
            columns.forEach(column => {
                if (validateSimilarity(column, item.regExpWords)) {
                    // console.log(`Se encontro ${item.label} es parecido ${column}`);
                    if (fieldMapToSet[`${item.varName}ColumnMatched`] === '') {
                        fieldMapToSet[`${item.varName}ColumnMatched`] = column;
                        stateToSet[`${item.varName}TableValidation`] = column;
                    }
                }
                // console.log(item.label, column);
            });
        });
        // console.table(fieldMapToSet);
        setState(prev => (Object.assign(Object.assign(Object.assign({}, prev), { isLoading: false, fieldMap: fieldMapToSet }), stateToSet)));
    };
    useEffect(() => {
        if (!fieldMap.firstMapping)
            doFirstMapping();
    }, []);
    const getPreviewInfo = (nameField) => {
        // console.log(`label(${label}) nameField(${nameField})`);
        if (['', 'skip', null].includes(nameField)) {
            return React.createElement("div", { className: Styles.disableText }, "Select column to view");
        }
        // returns first 2 records
        return buildPreview(data[0][nameField], data[1][nameField]);
    };
    const listTable = REQUIRED_FIELDS.map((item, key) => {
        return {
            matched: (React.createElement("div", { style: { textAlign: 'center' } }, state[`${item.varName}TableValidation`] ? (React.createElement(IconCircleCheck, { color: state[`${item.varName}TableValidation`] === 'skip' ? '#666' : '#89C900' })) : (React.createElement(IconCircleClose, { color: "#EC526E" })))),
            requiredInfo: (React.createElement("span", { style: { color: state[`${item.varName}TableValidation`] ? 'inherit' : '#EC526E' } }, item.label)),
            dropdowns: (React.createElement(SelectKV, { name: `${item.varName}TableValidation`, value: state[`${item.varName}TableValidation`], varNameTable: `${item.varName}ColumnMatched`, stateParam: uploadFromCsvStudentState }, options)),
            previewInfo: getPreviewInfo(fieldMap[`${item.varName}ColumnMatched`])
        };
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: Styles.step1Wrap },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { className: Styles.col1 }, "Matched"),
                        React.createElement("th", { className: Styles.col2 }, "Required Information"),
                        React.createElement("th", { className: Styles.col3 }, "Columns From Your File"),
                        React.createElement("th", { className: Styles.col4 }, "Preview Information"))),
                React.createElement("tbody", null, REQUIRED_FIELDS.map((item, key) => (React.createElement("tr", { key: `${item.label}_${key}` },
                    React.createElement("td", null,
                        React.createElement("div", { style: { textAlign: 'center' } }, state[`${item.varName}TableValidation`] ? (React.createElement(IconCircleCheck, { color: state[`${item.varName}TableValidation`] === 'skip' ? '#666' : '#89C900' })) : (React.createElement(IconCircleClose, { color: "#EC526E" })))),
                    React.createElement("td", null,
                        React.createElement("span", { style: { color: state[`${item.varName}TableValidation`] ? 'inherit' : '#EC526E' } }, item.label)),
                    React.createElement("td", null,
                        React.createElement(SelectKV, { name: `${item.varName}TableValidation`, value: state[`${item.varName}TableValidation`], varNameTable: `${item.varName}ColumnMatched`, stateParam: uploadFromCsvStudentState }, options)),
                    React.createElement("td", null, getPreviewInfo(fieldMap[`${item.varName}ColumnMatched`])))))))),
        React.createElement("div", { className: Styles.body },
            React.createElement(CustomBootstrapTable, { keyField: "id", data: listTable, columns: columns1, showMobile: isMobile }))));
};
export default Step1;
